import { useSelector } from 'react-redux';

import { PERMISSIONS, SUPPLIER_ROLES } from 'constants/all';

import ConfigItemListPage from 'modules/configurePages/configItemListPage/ConfigItemListPage';

import { getGroupMemberSupplierRoles } from 'store/session/selectors';

import QuoteWorkflowSteps from './QuoteWorkflowSteps';
import WorkStepsList from './WorkStepsList';
import WorkflowModal from './workflowModal/WorkflowModal';

const WorkflowsPage = () => {
  const isReadOnlyPermission =
    useSelector(getGroupMemberSupplierRoles)[SUPPLIER_ROLES.PROCESSES] ===
    PERMISSIONS.READ_ONLY;
  return (
    <ConfigItemListPage pageTitle="Workflows">
      <QuoteWorkflowSteps isReadOnlyPermission={isReadOnlyPermission} />
      <WorkStepsList isReadOnlyPermission={isReadOnlyPermission} />
      <WorkflowModal />
    </ConfigItemListPage>
  );
};

export default WorkflowsPage;
